
export default function getInitState() {
    return {
        appointmentStatusFormIsOpen: false,
        appointmentStatusGridIsOpen: true,

        actions: [

        ],

        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGrid'
            },
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Módosítás',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'editRow',
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "text",
                label: "Státusz",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "tag",
                label: "Tag",
                visibility: false,
                formReadOnly: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "color",
                label: "Színkód",
                visibility: true,
                formType: 'color',
                formSize: 4,
                formVisible: true,
                formRequired: true,
                slot_name: "appointment_status_color"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ],
        searchFields: [
            {
                name: "text",
                label: "Státusz",
                formSize: 3,
                formType: 'text',
            }
        ]
    }
}